import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SubscribeModal from "../landing/SubscribeModal";
import { useState } from "react";
import SiteLogo from "../SiteLogo";

function FooterFigma() {
  const { t } = useTranslation();
  const [NewsLetterClick, setNewsLetterClick] = useState(false);
  const [show, setShow] = useState(false);

  const handleSubscribeClick = () => {
    setNewsLetterClick(true); // Triggers modal open
    setShow(true);
  };

  return (
    <div className="pg-footer bg-light">
      <footer className="footer rounded-4">
        <div className="text-center m-0 pt-5 px-2">
          <h5 className="fw-bold">
            {t("@All-prices-including-taxes-and-fees")}
          </h5>
          <hr />
        </div>
        <div className="container pt-0">
          <div className="row justify-content-center">
            {/* Company Column */}
            <div className="col-6 col-md-4 col-lg-3">
              <SiteLogo className="w-100 d-flex align-items-start" />
            </div>
            <div className="col-6 col-md-4 col-lg-2">
              <div className="footer-menu">
                <h2 className="footer-menu-name">{t("Company")}</h2>
                <ul id="menu-company" className="footer-menu-list">
                  <li className="footer-links-color">
                    <Link to="/about-us">{t("About-Us")}</Link>
                  </li>
                  <li className="footer-links-color">
                    <Link to="/contact-us">{t("Contact-Us")}</Link>
                  </li>
                  <li className="footer-links-color">
                    <Link to="/faqs">{t("FAQS")}</Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Quick Links Column */}
            <div className="col-6 col-md-4 col-lg-2">
              <div className="footer-menu">
                <h2 className="footer-menu-name">{t("Quick-Links")}</h2>
                <ul id="menu-quick-links" className="footer-menu-list">
                  <li className="footer-links-color">
                    <Link rel="noopener noreferrer" to="/ask-a-questions">
                      {t("Support-Center")}
                    </Link>
                  </li>
                  <li className="footer-links-color">
                    <Link
                      to="/user-profile"
                      state={{ activeComponent: "my-orders" }}
                      rel="noopener noreferrer"
                    >
                      {t("Track-Orders")}
                    </Link>
                  </li>

                  {/* <li className="footer-links-color">
                    <Link to="/blog">{t("Blog")}</Link>
                  </li> */}
                  <li className="footer-links-color">
                    <Link to="/happy-customers">{t("Happy-Customers")}</Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Legal Column */}
            <div className="col-6 col-md-4 col-lg-2">
              <div className="footer-menu">
                <h2 className="footer-menu-name">Legal</h2>
                <ul id="menu-legal" className="footer-menu-list">
                  <li className="footer-links-color">
                    <Link to="/terms&condition">{t("Terms&Conditions")}</Link>
                  </li>
                  <li className="footer-links-color">
                    <Link to="/refund-policies">{t("Refund-Policies")}</Link>
                  </li>
                  <li className="footer-links-color">
                    <Link to="/return-policies">{t("Return-Policies")}</Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Call to Action Column */}
            <div className="col-9 col-md-4 col-lg-3">
              <div className="footer-call-to-action d-flex flex-column align-items-center">
                <div>
                  <h2 className="footer-call-to-action-title">
                    {t("Lets-Chat")}
                  </h2>
                  <p className="footer-call-to-action-description">
                    {t("Have-a-support-question?")}
                  </p>
                  <Link
                    className="footer-call-to-action-button"
                    to="/ask-a-questions"
                  >
                    {t("Ask-a-question")}
                  </Link>
                </div>
              </div>
              {/* <div className="footer-call-to-action mt-0 pt-0">
                <p className="footer-call-to-action-description">
                  {t("Would you like to Subscribe to our Newsletter?")}
                </p>
                <Link
                  className="footer-call-to-action-button"
                  to="#"
                  onClick={handleSubscribeClick}
                >
                  {t("Subscribe Now")}
                </Link>

                <SubscribeModal
                  show={show}
                  setShow={setShow}
                  NewsLetterClick={NewsLetterClick}
                  setNewsLetterClick={setNewsLetterClick}
                />
              </div> */}
            </div>
          </div>

          <div className="row pt-3">
            {/* <div className="col-12 d-flex justify-content-center gap-3">
              <Link
                className="footer-social-link linkedin text-white"
                to="#"
                target="_blank"
              >
                <FontAwesomeIcon icon={["fab", "linkedin-in"]} />
              </Link>
              <Link
                className="footer-social-link twitter text-white"
                to="#"
                target="_blank"
              >
                <FontAwesomeIcon icon={["fab", "twitter"]} size="2x" />
              </Link>
              <Link
                className="footer-social-link youtube text-white"
                to="#"
                target="_blank"
              >
                <FontAwesomeIcon icon={["fab", "youtube"]} />
              </Link>
              <Link
                className="footer-social-link github text-white"
                to="#"
                target="_blank"
              >
                <FontAwesomeIcon icon={["fab", "github"]} size="2x" />
              </Link>
            </div> */}
          </div>
        </div>
        <hr />
        <div className="footer-copyright pt-4">
          <div className="footer-copyright-wrapper">
            <p className="footer-copyright-text fw-bold fs-6">
              {t("Copyright")}
              <Link
                className="footer-copyright-link ps-1"
                to="https://alltrients.de"
                target="_self"
              >
                alltrients.de
              </Link>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default FooterFigma;
